import { v4 as uuidv4 } from 'uuid';

const traceId = uuidv4();

export default traceId;